import { createSelector } from 'reselect';

/** @return {import("../reducers").FollowUpReducer} */
const getState = state => state.followUp;

export const getRoot = state => state;

const getProps = (_, props) => props;

const getDataState = createSelector(getState, state => state.data);

const getDataEntities = createSelector(getDataState, state => state.entities);

export const getUIState = createSelector(getState, state => state.ui);

export const getFollowUpById = createSelector(
  getDataEntities,
  getProps,
  (entities, followUpId) => entities[followUpId]
);

export const getFollowUpByIds = createSelector(getDataEntities, getProps, (entities, followUpIds = []) =>
  followUpIds.reduce((acc, followUpId) => {
    const entity = entities[followUpId];
    if (entity) {
      return [...acc, entity];
    }
    return acc;
  }, []));
